import {
  // paymentMethod:
  SET_PAYMENT_METHOD,
  // paymentProfileForm:
  SET_PAYMENT_PROFILE_FORM
} from './actionTypes'

// paymentMethod:

export const setPaymentMethod = paymentMethod => {
  return {
    type: SET_PAYMENT_METHOD,
    paymentMethod
  }
}

// paymentProfileForm:

export const setPaymentProfileForm = paymentProfile => {
  return {
    type: SET_PAYMENT_PROFILE_FORM,
    paymentProfile
  }
}
